import {Component, inject, OnInit} from '@angular/core';
import {CompanyOfficeDetailResponse} from '@frontend/shared-api';
import {OfficeListService} from '../../../../shared/components/office-list/office-list.service';
import {Router} from '@angular/router';
import {TableModule} from 'primeng/table';
import {TranslocoDirective} from '@jsverse/transloco';
import {CountryService} from '@frontend/shared';
import {
  OfficeListComponent,
  TableColumn,
} from '../../../../shared/components/office-list/office-list.component';
import {APP_ROUTES} from '../../../../app.routes';

@Component({
  selector: 'app-company-list',
  imports: [TableModule, TranslocoDirective, OfficeListComponent],
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss'],
})
export class CompanyListComponent implements OnInit {
  protected readonly countryService = inject(CountryService);
  private readonly companyListService = inject(OfficeListService);
  private readonly router = inject(Router);

  offices: CompanyOfficeDetailResponse[] = [];
  loading = false;

  /** our generic columns config */
  companyListColumns: TableColumn[] = [
    {field: 'companyName', headerKey: 'common.companyName', testId: 'company-name', width: '20%'},
    {field: 'countryCode', headerKey: 'common.country', testId: 'country', width: '18%'},
    {field: 'cityName', headerKey: 'common.city', testId: 'city', width: '18%'},
    {field: 'officeName', headerKey: 'common.office', testId: 'office', width: '18%'},
    {field: 'projects', headerKey: 'common.projectAssigned', testId: 'project', width: '26%'},
  ];

  ngOnInit(): void {
    this.fetchOffices();
  }

  private fetchOffices(): void {
    this.loading = true;
    this.companyListService.getAllOfficesWithDetails().subscribe({
      next: (data) => {
        this.offices = data;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  editCompany(companyId: number): void {
    this.router.navigate([APP_ROUTES.COMPANY, companyId, APP_ROUTES.EDIT]);
  }

  navigateToCreate(): void {
    this.router.navigate([APP_ROUTES.COMPANY + APP_ROUTES.CREATE]);
  }
}
